import { Environment } from './environment.interface';
import versionInfo from '../../../version.json';
import { ApplicationComponent } from '../../../common/dto/app.dto';

export const environment: Environment = {
  production: true,

  version: versionInfo.version,

  serverUrl: 'https://api.rpgbench.com',

  logging: {
    enabled: true,

    dsn: 'https://df9dc51f173c849fe1c27548c51bc4eb@o4506331993407488.ingest.sentry.io/4506332001927168',
  },

  tracking: {
    enabled: true,
  },

  links: {
    discordUrl: 'https://discord.gg/ae8ETCCf',
    patreonUrl: 'https://patreon.com/RPGBench',
    websiteUrl: 'https://www.rpgbench.com',
    supportEmail: 'support@rpgbench.com',
  },

  appComponentUrls: {
    [ApplicationComponent.App]: 'https://www.rpgbench.com',
    [ApplicationComponent.Login]: 'https://login.rpgbench.com',
  },
};
